import { formatMonthDateYear } from '@dataGrid/gridUtilities';

const holidayRangeValueFormatter = (params) => {
  const holidays = params.data.holidays;
  if (!holidays) {
    return [];
  }
  return holidays.map((holiday) => getHolidayDateValue({ data: holiday }));
};

const holidayRangeValueGetter = (params) => {
  return params.data.holidays.map((holiday) => holidayValueGetter({ data: holiday }));
};

const holidayValueGetter = (params) => {
  return formatMonthDateYear({ value: params.data.holidayDate });
};

const getCustomerHolidayValidationsProps = (holidays, selectedOption) => {
  const isHolidayAlreadyAdded = holidays?.some(
    (holiday) => holiday.holidayId === selectedOption?.value
  );
  const isSameDayAlreadyAdded = holidays?.some(
    (holiday) => holiday.holidayDate === selectedOption?.holidayDate
  );
  return { isHolidayAlreadyAdded, isSameDayAlreadyAdded };
};

const getHolidayDateValue = (params) => {
  if (params.data.isCustomerSpecificHoliday) {
    if (params.data.holidayDate && params.data.holidayEndDate) {
      return `${formatMonthDateYear({ value: params.data.holidayDate })} - ${formatMonthDateYear({
        value: params.data.holidayEndDate
      })}`;
    } else {
      return '';
    }
  } else {
    return formatMonthDateYear({ ...params, value: params.data.holidayDate });
  }
};

const getCustomerSpecificHolidayValidations = (holidays, dateRange) => {
  let errorMessage = null;
  const isSameDayAlreadyAdded =
    dateRange?.holidayStartDate === dateRange?.holidayEndDate &&
    holidays?.some((holiday) => holiday.holidayDate === dateRange?.holidayStartDate);
  if (isSameDayAlreadyAdded) {
    errorMessage = 'Another holiday is already added on the same day!';
  }
  return errorMessage;
};

const getDriverHolidayMarkedByValue = (params) => {
  const markedBy = params.data?.driverHolidayMarkedBy;
  const driverName = markedBy?.driverName;
  const driverNumber = markedBy?.driverNumber;

  if (!driverName && !driverNumber) {
    return '';
  }

  return [driverName, driverNumber ? `(${driverNumber})` : null].filter(Boolean).join(' ');
};

const getDriverHolidayMarkedOnValue = (params) => {
  const markedDateTime = params.data?.driverHolidayMarkedBy?.markedDateTime;
  return markedDateTime ? formatMonthDateYear({ value: markedDateTime }) : '';
};

const getDriverHolidayConfirmationValue = (params) => {
  const driver = getDriverHolidayMarkedByValue(params);
  const markedOn = getDriverHolidayMarkedOnValue(params);

  if (!driver && !markedOn) {
    return '';
  }

  if (driver && markedOn) {
    return `${driver} — ${markedOn}`;
  }

  return driver || markedOn;
};

const getCustomerHolidayGridRowId = (holiday = {}) => {
  const { holidayId, holidayDate, holidayName } = holiday;
  return [holidayId, holidayDate, holidayName].filter(Boolean).join('|');
};

export {
  holidayRangeValueGetter,
  holidayRangeValueFormatter,
  getCustomerHolidayValidationsProps,
  getHolidayDateValue,
  holidayValueGetter,
  getCustomerSpecificHolidayValidations,
  getDriverHolidayMarkedByValue,
  getDriverHolidayMarkedOnValue,
  getDriverHolidayConfirmationValue,
  getCustomerHolidayGridRowId
};
